var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 32",
    style: {
      enableBackground: "new 0 0 36 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.8,4.6c-1.2,0-2.3,1-2.3,2.3v18.3c0,1.3,1,2.3,2.3,2.3h4.5c1.2,0,2.3,1,2.3,2.3c0,1.3-1,2.3-2.3,2.3H6.8 C3,32,0,28.9,0,25.1V6.9C0,3.1,3,0,6.8,0h4.5c1.2,0,2.3,1,2.3,2.3s-1,2.3-2.3,2.3H6.8z M25.3,27c-0.5,0.5-1.2,0.6-1.8,0.3 c-0.6-0.3-1-0.9-1-1.6v-5.1h-9c-1.2,0-2.3-1-2.3-2.3v-4.6c0-1.3,1-2.3,2.3-2.3h9V6.3c0-0.7,0.4-1.3,1-1.6c0.6-0.3,1.3-0.1,1.8,0.3 l10.1,9.7c0.3,0.3,0.5,0.8,0.5,1.2c0,0.5-0.2,0.9-0.5,1.2L25.3,27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutWhite);
export default __webpack_public_path__ + "static/media/Logout_White.034da1aceb93d310fcfd706e20aa3932.svg";
export { ForwardRef as ReactComponent };